import { Routes } from '@angular/router'
import { AcessoComponent } from './acesso/acesso.component'
import { HomeComponent } from './home/home.component'
import { PainelControleComponent } from './painel-controle/painel-controle.component'

import { AuthenticatorComponent } from './acesso/authenticator/authenticator.component'
import { CadastroFichaMonitoriaComponent } from './acesso/cadastro-ficha-monitoria/cadastro-ficha-monitoria.component'
import { CadastroOperacaoComponent } from './acesso/cadastro-operacao/cadastro-operacao.component'
import { CadastroUsuarioComponent } from './acesso/cadastro-usuario/cadastro-usuario.component'
import { ExclusaoMonitoriaPendenteComponent } from './acesso/exclusao-monitoria-pendente/exclusao-monitoria-pendente.component'
import { MonitoriaComponent } from './acesso/monitoria/monitoria.component'
import { ParecerPlanoAcaoComponent } from './acesso/parecer-plano-acao/parecer-plano-acao.component'


export const ROUTES: Routes = [
    { path: '', component: AcessoComponent },
    { path: 'authenticator', component: AuthenticatorComponent},
    { path: 'home', component: HomeComponent,
        children: [
            {path : 'painel', component: PainelControleComponent},
            {path : 'monitoria', component: MonitoriaComponent},
            {path : 'formulariosPendentes', component: PainelControleComponent},
            {path : 'exclusoesPendentes', component: ExclusaoMonitoriaPendenteComponent},
            {path : 'parecerPlanoDeAcao', component: ParecerPlanoAcaoComponent},

            {path : 'cadFichaMonitoria', component: CadastroFichaMonitoriaComponent},
            {path : 'cadOperacao', component: CadastroOperacaoComponent},
            {path : 'cadUsuario', component: CadastroUsuarioComponent},        ]
    },

]
